'use strict';

const translationForChile = require('../translations/falabella-cl');

const constants = require('../constants');

const {
  TENANT: { CHILE },
} = constants;

const translationsLookup = {
  [CHILE]: translationForChile,
};

const DEFAULT_MESSAGE =
  '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.';

// eslint-disable-next-line default-param-last
function translateErrors(errors, allTranslations = {}, defaultMessage) {
  if (!Array.isArray(errors)) return [];
  const { DEFAULT: defaultTranslation, ...translations } = allTranslations;
  const errorSet = new Set(errors.filter(({ code }) => !!code).map(({ code }) => code));
  const errorCodes = Array.from(errorSet);
  return errorCodes.map((code) => ({
    code,
    message: translations[code] || defaultMessage || defaultTranslation || DEFAULT_MESSAGE,
  }));
}

function withErrorTranslation(method, translationKey, defaultMessage) {
  async function methodWithErrorTranslation(params) {
    const { tenantId = CHILE } = params;
    const { errors, ...otherFields } = await method(params);
    const tenantTranslations = translationsLookup[tenantId] || translationForChile;
    const translations = tenantTranslations.ERRORS[translationKey];
    const translatedErrors = translateErrors(errors, translations, defaultMessage);
    return { errors: translatedErrors, ...otherFields };
  }
  return methodWithErrorTranslation;
}

module.exports = { translateErrors, withErrorTranslation };
